import { UnstakeSpkAction } from '../types'
import { spkStakingModuleAddress, spkStakingModuleConfig } from '@/config/contracts-generated'
import { getContractAddress } from '@/domain/hooks/useContractAddress'
import { ensureConfigTypes } from '@/features/actions/logic/transactions/useWrite'
import { ActionConfig, ActionContext } from '@/features/actions/logic/types'
import { spkStakingDataQueryKey } from '@/features/spk/staking/logic/useSpkStakingData'

export function createUnstakeSpkActionConfig(action: UnstakeSpkAction, context: ActionContext): ActionConfig {
  const { account, chainId } = context
  const vault = getContractAddress(spkStakingModuleAddress, chainId)

  return {
    getWriteConfig: () => {
      const { spk, amount, accountActiveShares, unstakeAll } = action

      if (unstakeAll) {
        return ensureConfigTypes({
          address: vault,
          abi: spkStakingModuleConfig.abi,
          functionName: 'redeem',
          args: [account, accountActiveShares.toBigInt()],
        })
      }

      return ensureConfigTypes({
        address: vault,
        abi: spkStakingModuleConfig.abi,
        functionName: 'withdraw',
        args: [account, spk.toBigInt(amount)],
      })
    },

    invalidates: () => {
      return [spkStakingDataQueryKey({ account, chainId })]
    },
  }
}
